import { render, staticRenderFns } from "./sso-apple.vue?vue&type=template&id=1c099f80&"
import script from "./sso-apple.ts?vue&type=script&lang=ts&"
export * from "./sso-apple.ts?vue&type=script&lang=ts&"
import style0 from "./sso-apple.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports